import { WebPageType } from '../../constants/webPageType';
import useRedirectEntry from '../../hooks/useRedirectEntry';

export const WEANotFound: React.FC = () => {
  useRedirectEntry({ webPageType: WebPageType.WEA });

  return <></>;
};

export default WEANotFound;
